// extracted by mini-css-extract-plugin
module.exports = {"fragmentPage":"FragmentPage_fragmentPage__DZg8c","components":"FragmentPage_components__JE3wm"};